import { SET_LIST_DATA_LENGTH } from 'root/src/client/logic/list/actionIds'

export default (listDataLength, moduleId) => ({
	type: SET_LIST_DATA_LENGTH,
	payload: { listDataLength, moduleId },
})
